var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { LoadingContextProvider, MessagesProvider, useLoadingContext } from "@lululemon/auth-common";
import styles from "./signin-widget-with-providers.module.scss";
import { useEffect, useState, lazy, Suspense } from "react";
var LazySigninWidget = lazy(function () {
    return import(
    /* webpackChunkName: "LoginV3"*/
    "./signin-widget");
});
var SigninWidget = function (props) {
    var setIsLoading = useLoadingContext().setIsLoading;
    var _a = useState(false), isWidgetReady = _a[0], setIsWidgetReady = _a[1];
    useEffect(function () {
        setIsLoading(!isWidgetReady);
    }, [isWidgetReady]);
    return (<LazySigninWidget {...props} onReady={function () {
            setIsWidgetReady(true);
        }}/>);
};
var SigninWidgetWithProvidersContainer = function (props) {
    var initialMessages = props.initialMessages, signinWidgetProps = __rest(props, ["initialMessages"]);
    return (<div className={styles.widgetContainer}>
      <MessagesProvider initialMessages={initialMessages}>
        <LoadingContextProvider>
          <Suspense>
            <SigninWidget {...signinWidgetProps}/>
          </Suspense>
        </LoadingContextProvider>
      </MessagesProvider>
    </div>);
};
export default SigninWidgetWithProvidersContainer;
